export default class GameMain {
    constructor() {
        this.words = [];
        this.the_word = "";
        this.the_year = "";
        this.special = false;
        this.in_animation = false;
        this.firstPlay = true;
        this.init();
    }

    init() {
        this.setup();
    }

    setup() {
        //JSON3つを全てロード次第、スタート
        $.when(
            $.getJSON("./assets/data/2015.json"),
            $.getJSON("./assets/data/2016.json"),
            $.getJSON("./assets/data/2017.json"),
            $.getJSON("./assets/data/2018.json"),
            $.getJSON("./assets/data/2019.json"),
            $.getJSON("./assets/data/2020.json"),
            $.getJSON("./assets/data/2021.json"),
            $.getJSON("./assets/data/2022.json")
        ).done((data_2015, data_2016, data_2017, data_2018, data_2019, data_2020, data_2021, data_2022) => {
            this.words[1] = { id: "2015", data: data_2015[0] };
            this.words[2] = { id: "2016", data: data_2016[0] };
            this.words[3] = { id: "2017", data: data_2017[0] };
            this.words[4] = { id: "2018", data: data_2018[0] };
            this.words[5] = { id: "2019", data: data_2019[0] };
            this.words[6] = { id: "2020", data: data_2020[0] };
            this.words[7] = { id: "2021", data: data_2021[0] };
            this.words[8] = { id: "2022", data: data_2022[0] };

            console.log(this.words);

            //データが用意でき次第、イベントバインドする
            this.setEvents();
        });
    }

    setEvents() {
        const that = this;

        $(".pullbtn").on("click", function () {
            //アニメーションの多重起動防止
            if (that.in_animation) {
                return;
            }

            //ワード選別
            pickupWord();

            //レア画面を常に出す機能もデバッグ用に設置
            if (COMMON.query["rare"]) {
                wordBack(true);
            } else {
                wordBack(that.special);
            }

            //アニメーション
            cardOpen();
        });

        function wordBack(isSpecial) {
            const tl = new TimelineMax();

            //specialバージョン
            if (isSpecial) {
                //setup
                tl.set(".cutin__01", { x: 750, y: "-50%" });
                tl.set(".cutin", { display: "block" });

                tl.to(".cutin__01", 0.2, { x: 0 }, 0.2);
                tl.to(".cutin__01", 0.2, { x: -750 }, 1);

                tl.fromTo(".word__special", 0.5, { opacity: 0, scale: 0, display: "none" }, { opacity: 1, scale: 1, ease: Back.easeOut, display: "block" }, 1);
                tl.fromTo(".word__light", 0.5, { opacity: 0, display: "none" }, { opacity: 0.4, display: "block" }, 1);
                tl.to(".word__light", 0.2, { opacity: 1 }, 1.8);
                tl.to(".word__light", 1, { opacity: 0.6 }, 2.5);

                //クレジット情報更新
                $(".word__person").text("〈" + that.the_word["引いた人"] + "〉");
                let imgpath = `assets/img/logo/logo_${that.the_year}.png`;
                $(".word__place img").attr("src", imgpath);
            } else {
                //setup
                tl.set(".cutin", { display: "none" });

                tl.to(".word__special", 0.5, { opacity: 0, display: "none" }, 0);
                tl.fromTo(".word__light", 0.5, { opacity: 0, display: "none" }, { opacity: 0.4, display: "block" }, 1);
                tl.to(".word__light", 0.2, { opacity: 1 }, 1.8);
                tl.to(".word__light", 1, { opacity: 0.6 }, 2.5);
            }
        }

        //カードが出てくるアニメーション
        function cardOpen() {
            //アニメーションフラグ
            that.in_animation = true;

            //初期化
            const tl = new TimelineMax({
                onComplete: function () {
                    //フラグのコンプリート
                    that.in_animation = false;
                    that.firstPlay = false;
                },
            });

            tl.set(".word__txt,.tweetbtn", { opacity: 0, scale: 0 });
            tl.set(".word__overlay", { opacity: 0 });
            tl.call(
                function () {
                    bagChange();
                },
                null,
                null,
                0
            );

            //バッグシェイク→画面外へワードを投げ
            tl.fromTo(".stage__bag", 0.1, { x: -20 }, { x: 20, repeat: 6, yoyo: true }, 0);
            tl.to(".stage__bag", 0.2, { x: 0, y: 0, rotation: 0 }, 0.6);
            tl.to(".paper", 0.5, { x: -800, scale: 0.5, rotation: "180deg", ease: Circ.easeOut }, 0);

            //ワード出現
            tl.to(".paper", 0, { opacity: 0, x: 0, scale: 0, y: 800, rotation: "180deg" }, 0.5);
            tl.to(".paper", 0.5, { x: 0, y: 0, scale: 1, opacity: 1, rotation: 0, ease: Circ.easeOut }, 1);
            tl.to(".word__overlay", 0.5, { opacity: 1 }, 1);

            tl.call(
                function () {
                    txtShuffle();
                },
                null,
                null,
                1
            );
            tl.call(
                function () {
                    paperOpen();
                },
                null,
                null,
                1
            );

            tl.to(".word__txt", 0.5, { opacity: 1, scale: 1, ease: Back.easeOut }, 1.8);
            tl.to(".tweetbtn", 0.5, { opacity: 1, scale: 1, ease: Back.easeOut }, 1.8);
        }

        function pickupWord() {
            const ry = Math.floor(Math.random() * that.words.length);
            const rn = Math.floor(Math.random() * that.words[ry].data.length);
            that.the_word = that.words[ry].data[rn];
            that.the_year = that.words[ry].id;
            setShareURL(); //シェアURLのセット

            //スペシャルワードかどうかの判定
            if (that.the_word["引いた人"]) {
                that.special = true;
            } else {
                that.special = false;
            }
        }

        function setShareURL() {
            //シェアを書き換え
            const txt = "【#モバLIVE】いつでも、どこでも、アドリブワードで盛り上がろう！スマホでアドリブ 引いたワード「" + that.the_word["ワード"] + "」";
            const siteurl = encodeURIComponent("https://ad-live-project.com/mobalive/");
            const hashtag = encodeURIComponent("ad_live");
            const url = "https://twitter.com/intent/tweet?url=" + siteurl + "&hashtags=" + hashtag + "&text=" + encodeURIComponent(txt);
            $(".tweetbtn").attr("href", url);
        }

        function paperOpen() {
            $(".paper__item").addClass("anim");
        }

        function txtShuffle() {
            $(".word__txt").text(that.the_word["ワード"]);
        }

        //todo:数は自動的に対応
        function bagChange() {
            if (that.firstPlay) {
                return;
            }
            const rn = Math.floor(Math.random() * 23) + 1;
            const classname = "bag" + rn;
            // 'bag' で始まるclassをすべて削除
            $(".stage__bag").removeClass(function (index, className) {
                return (className.match(/\bbag\S+/g) || []).join(" ");
            });
            $(".stage__bag").addClass(classname);
        }
    }
}
